export function calculateWidthInPixelsForThreadByThread(widthInDents: number, nrColumnsForWeftSelection: number, nrCloths: number, nrGroundYarns: number): number {
  let widthInPixels = widthInDents;
  if (nrGroundYarns > 0) {
    let numberOfPixelsPerDent = nrGroundYarns / Math.max(1, nrCloths);
    widthInPixels *= numberOfPixelsPerDent;
  }
  return widthInPixels + nrColumnsForWeftSelection;
}
